import React, { useEffect, useState } from 'react'
import IconsTextNavigation from 'components/global/IconsTextNavigation'
import { creationEventStore } from 'state/event/eventCreationStore'
import ItemsToBringModal from 'pages/Events/Views/Common/Modals/ItemsToBring'

const ItemstoBring: React.FC = () => {
  const { eventData, itemsToBring, setItemsToBring } = creationEventStore(
    store => ({
      eventData: store.eventData,
      itemsToBring: store.itemsToBring,
      setItemsToBring: store.setItemsToBring,
    }),
  )
  const [openItemsModal, setOpenItemsModal] = useState<boolean>(false)

  return (
    <>
      <div onClick={() => setOpenItemsModal(true)}>
        <IconsTextNavigation
          iconName="ShoppingBagOpen"
          heading="Items to bring"
          isCompleted={itemsToBring.length > 0 ? true : false}
        />
      </div>
      {openItemsModal && (
        <ItemsToBringModal
          openModal={openItemsModal}
          closeModal={setOpenItemsModal}
          prevItems={itemsToBring}
          setPrevItems={setItemsToBring}
          organizationId={eventData.organizationId}
        />
      )}
    </>
  )
}

export default ItemstoBring
